import { motion, useReducedMotion } from "framer-motion";
import { CalendarDays, MapPin, ArrowDown } from "lucide-react";
import { FondoVideoAmbient } from "../../shared";

export default function Portada({ datos }) {
  const { protagonista, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className="fe-portada" data-testid="fe-portada">
      <div className="fe-portada-texto">
        <motion.p className="fe-portada-frase" {...entrar(0.1)}>
          {protagonista.fraseIntroductoria}
        </motion.p>
        <motion.h1 className="fe-portada-titulo" data-testid="fe-nombre" {...entrar(0.25)}>
          {protagonista.nombre}
        </motion.h1>
        <motion.div className="fe-portada-chips" {...entrar(0.4)}>
          <span className="fe-chip" data-testid="fe-fecha">
            <CalendarDays size={15} strokeWidth={1.8} />
            {evento.fechaLegible}
          </span>
          <span className="fe-chip">
            <MapPin size={15} strokeWidth={1.8} />
            {evento.ciudad}
          </span>
        </motion.div>
        <motion.p className="fe-portada-mensaje" {...entrar(0.55)}>
          {protagonista.mensajePortada}
        </motion.p>
        {protagonista.textoBotonEntrada && (
          <motion.a href="#fe-contenido" className="fe-boton" data-testid="fe-boton-bajar" {...entrar(0.7)}>
            {protagonista.textoBotonEntrada}
            <ArrowDown size={15} strokeWidth={2} />
          </motion.a>
        )}
      </div>
      <motion.div className="fe-portada-marco" {...entrar(0.45)}>
        {datos.portadaVideo?.urlYoutube ? (
          <FondoVideoAmbient
            urlYoutube={datos.portadaVideo.urlYoutube}
            poster={datos.portadaVideo.poster || fotos.portada}
          />
        ) : (
          <img
            className="fe-portada-foto"
            src={fotos.portada}
            alt={`Imagen de ${protagonista.nombre}`}
          />
        )}
      </motion.div>
    </header>
  );
}
